export interface SalesforceTaskResponse {
  id: string;
  success: boolean;
  errors: string[];
}

export interface SfActivityTask {
  RecordTypeId: string;
  WhatId: string;
  Subject: string;
  Status: string;
  Priority: string;
  OwnerId: string;
  Description: string;
  Demo_Trial_Resource__c: string;
  TaskSubtype: string;
  SE_Service_Type__c: string | null;
  Technology__c: string;
  Business_Entity_Type__c: string;
  Security_Concierge__c: boolean;
  ActivityDate: string;
  ReminderDateTime: string;
}

export interface PicklistValue {
  active: boolean;
  defaultValue: boolean;
  label: string | null;
  validFor: string | null;
  value: string | null;
}

export enum SfRecordType {
  Opportunity = 'Opportunity',
  Customer = 'Account'
}

export interface SfField {
  aggregatable?: boolean | null;
  aiPredictionField?: boolean | null;
  autoNumber?: boolean | null;
  byteLength?: number | null;
  calculated?: boolean | null;
  calculatedFormula?: string | null;
  cascadeDelete?: boolean | null;
  caseSensitive?: boolean | null;
  compoundFieldName?: string | null;
  controllerName?: string | null;
  createable?: boolean | null;
  custom?: boolean | null;
  defaultValue?: any | null;
  defaultValueFormula?: string | null;
  defaultedOnCreate?: boolean | null;
  dependentPicklist?: boolean | null;
  deprecatedAndHidden?: boolean | null;
  digits?: number | null;
  displayLocationInDecimal?: boolean | null;
  encrypted?: boolean | null;
  externalId?: boolean | null;
  extraTypeInfo?: string | null;
  filterable?: boolean | null;
  filteredLookupInfo?: string | null;
  formulaTreatNullNumberAsZero?: boolean | null;
  groupable?: boolean | null;
  highScaleNumber?: boolean | null;
  htmlFormatted?: boolean | null;
  idLookup: boolean;
  inlineHelpText?: string | null;
  label?: string | null;
  length?: number | null;
  mask?: string | null;
  maskType?: string | null;
  name: string;
  nameField?: boolean | null;
  namePointing?: boolean | null;
  nillable?: boolean | null;
  permissionable?: boolean | null;
  picklistValues?: PicklistValue[] | null;
  polymorphicForeignKey?: boolean | null;
  precision?: number | null;
  queryByDistance?: boolean | null;
  referenceTargetField?: string | null;
  referenceTo?: string[] | null;
  relationshipName?: string | null;
  relationshipOrder?: number | null;
  restrictedDelete?: boolean | null;
  restrictedPicklist?: boolean | null;
  scale?: number | null;
  searchPrefilterable?: boolean | null;
  soapType?: string | null;
  sortable?: boolean | null;
  type?: string | null;
  unique?: boolean | null;
  updateable?: boolean | null;
  writeRequiresMasterRead?: boolean | null;
}

export interface ChildRelationship {
  cascadeDelete?: boolean | null;
  childSObject?: string | null;
  deprecatedAndHidden?: boolean | null;
  field?: string | null;
  junctionIdListNames?: string[] | null;
  junctionReferenceTo?: string[] | null;
  relationshipName?: string | null;
  restrictedDelete?: boolean | null;
}

export interface RecordTypeInfo {
  active?: boolean | null;
  available?: boolean | null;
  defaultRecordTypeMapping?: boolean | null;
  developerName?: string | null;
  master?: boolean | null;
  name?: string | null;
  recordTypeId: string;
  urls?: {
    layout: string | null;
  } | null;
}

export interface SupportedScope {
  label?: string | null;
  name?: string | null;
}

export interface Urls {
  compactLayouts?: string | null;
  rowTemplate?: string | null;
  approvalLayouts?: string | null;
  uiDetailTemplate?: string | null;
  uiEditTemplate?: string | null;
  listviews?: string | null;
  describe?: string | null;
  uiNewRecord?: string | null;
  quickActions?: string | null;
  layouts?: string | null;
  sobject?: string | null;
}

export interface SalesforceFieldConfig {
  name?: string;
  label?: string;
  source: string;
  value: string;
  type?: string;
}

export type SalesforcePermissions = Record<string, { permissions: SalesforcePermissionGroup }>;

export interface SalesforcePermissionGroup {
  read_only: SalesforceFieldConfig[],
  read_write: SalesforceFieldConfig[]
}

export type SalesforceSalesLevels = { [key: string]: SalesforceSalesLevels } | Record<string, never>;

// A sales level path (one possible full selection), e.g. ["Americas", "US COMMERCIAL", ...]
export type SalesforceSalesLevelPath = string[];

// Recursively collect all paths from the tree
export function flattenSalesLevelTree(
  tree: SalesforceSalesLevels,
  prefix: string[] = []
): SalesforceSalesLevelPath[] {
  const keys = Object.keys(tree);
  if (keys.length === 0) {
    // Leaf node
    return [prefix];
  }
  // Recurse
  return keys.flatMap(key =>
    flattenSalesLevelTree(
      (tree[key] as SalesforceSalesLevels) || {},
      [...prefix, key]
    )
  );
}